module.exports = __webpack_public_path__ + "static/img/长图设计-条漫.8c5fdea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10001/长图设计-条漫.png
// module id = PTGG
// module chunks = 1